'use client';

import { usePublicAnalytics } from '@/lib/analytics/use-public-analytics';

import { Suspense, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { isPostHogEnabledForPathname } from '@/lib/analytics/posthog-paths';

function PageView() {
  const publicAnalytics = usePublicAnalytics();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!publicAnalytics || typeof window === 'undefined' || !isPostHogEnabledForPathname(pathname)) {
      return;
    }

    const search = searchParams?.toString();
    const path = `${pathname || '/'}${search ? `?${search}` : ''}`;
    const payload = JSON.stringify({
      path,
      referrer: document.referrer || null,
    });

    const url = '/api/public-analytics/pageview/';
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }

    fetch(url, {
      method: 'POST',
      body: payload,
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
    }).catch(() => undefined);
  }, [pathname, searchParams, publicAnalytics]);

  return null;
}

export function PublicAnalyticsPageView() {
  return (
    <Suspense fallback={null}>
      <PageView />
    </Suspense>
  );
}
